import StockLedger from "@/pages/inventory/StockLedger";
export default function FinishedStock() {
  return (
    <StockLedger
      title="Finished product stock"
      subtitle="Manufactured tiles — semi-finished + finished + trading goods."
      ownerLabel="Warehouse Manager"
      filterTypes={["FINISHED", "SEMI_FINISHED", "TRADING"]}
      testid="finished-stock-page"
    />
  );
}
